<template>
    <div>
        <div class="assignee">
            <avatar :user="assignee.user" class="is-pulled-left is-32x32"/>
            <b class="name">{{assignee.user.first_name}} {{assignee.user.last_name}}</b>

            <i v-if="!remove.loading" @click="show_confirm = true"
               class="fas fa-times is-pulled-right pointer"></i>

            <div v-else class="loader is-pulled-right"></div>

            <div class="is-clearfix"></div>
        </div>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this Assignee?"
            @close="show_confirm = false"
            @ok="remove_assignee"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Avatar from '../common/Avatar.vue';

export default {
    components: { Avatar },
    props: ['space', 'column', 'card', 'assignee', 'in_note_editor'],
    data() {
        return { show_confirm: false };
    },
    computed: mapState('assignees', ['remove']),
    methods: {
        async remove_assignee() {
            this.show_confirm = false;

            await this.$store.dispatch('assignees/remove', {
                space_id: this.space.id,
                flow_id: this.card.flow.id,
                card_id: this.card.id,
                assignee_id: this.assignee.id,
            });

            if (this.in_note_editor) {
                this.$store.commit('cards/remove_assignee_from_details', {
                    assignee_id: this.assignee.id,
                });
                return;
            }

            this.$store.commit('cards/remove_assignee', {
                column_id: this.column,
                card_id: this.card.id,
                assignee_id: this.assignee.id,
            });
        },
    },
};
</script>

<style scoped>
    .assignee {
        margin: 1rem 0;
    }

    .assignee .name {
        margin-left: 0.7rem;
    }
</style>
